

import React, { useState, useEffect, useRef } from 'react'
import { Link } from "react-router-dom";
import { Select, Col, Row, Input, Checkbox } from "antd";
import backButton from '../../../assets/images/back_button_arrow.svg';
import siteIcon from '../../../assets/images/icons/site.svg';
import axios from "axios";
import { notifysuccess } from "../../../utils/toast";
import { notifyfailure } from "../../../utils/toast";
import { notifycatch } from "../../../utils/toast";
import Cookies from "js-cookie";
import configData from "../../../config/config.json";
import loaderIcon from "../../../assets/images/login-and-signup/loader.gif";
import demandIcon from '../../../assets/images/icons/demand_icon.svg';

const SiteCreateFreewheel = ({ handlePageViewChange }) => {

    // //////////////////////////////////////////////////////////////

    const scrollToItem = (ref, offset = 80) => {
        if (ref && ref.current) {
            ref.current.style.scrollMarginTop = `${offset}px`;
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
            setTimeout(() => {
                ref.current.style.scrollMarginTop = '';
            }, 500);
        }
    };

    const { TextArea } = Input;

    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            // Cleanup event listener on component unmount
            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
    });


    useEffect(() => {

        axios
            .get(configData.SERVER_URL + "ops/iabCategories", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setCategoryOptions_freewheel(response.data.data)

            })
            .catch((error) => { });



    }, [])

    const [buttonProcessing, setButtonProcessing] = useState(false);



    // ------------------------------  FreeWheel Code -----------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------

    const [name_freewheel, setName_freewheel] = useState("CTV_Xapads");
    const [nameIsRequiredError_freewheel, setNameIsRequiredError_freewheel] = useState(false);


    const [type_freewheel] = useState("Auto Populated (TV: Over-the-top)");

    const [category_freewheel, setCategory_freewheel] = useState("IAB1");
    const [categoryOptions_freewheel, setCategoryOptions_freewheel] = useState([]);

    const [checkbox_freewheeltv_freewheel, setCheckbox_freewheeltv_freewheel] = useState(false);

    const [passbackUrl_freewheel, setPassbackUrl_freewheel] = useState("");
    const regexDomain = /.+[.].+/;
    const [passbackUrlInvalidUrl_freewheel, setPassbackUrlInvalidUrl_freewheel] = useState(false);

    const [contactName_freewheel, setContactName_freewheel] = useState("Xapads ORTB");
    const [contactNameIsRequiredError_freewheel, setContactNameIsRequiredError_freewheel] = useState(false);

    const [contact_freewheel, setContact_freewheel] = useState("ortb@xapads.com");
    const [contactUrlError_freewheel, setContactUrlError_freewheel] = useState(false);
    const [contactIsRequiredError_freewheel, setContactIsRequiredError_freewheel] = useState(false);

    const [auctionType_freewheel, setAuctionType_freewheel] = useState("FIRST_PRICE");
    const [auctionTypeOptions_freewheel] = useState([{ label: "Default", value: "Default" }, { label: "First Price Auction", value: "FIRST_PRICE" }, { label: "Second Price Auction", value: "SECOND_PRICE" }]);

    // -----------------------------------------------------------------------------------------

    const [bundleName_freewheel, setBundleName_freewheel] = useState("");
    const [bundleId_freewheel, setBundleId_freewheel] = useState("");
    const [bundleVersion_freewheel, setBundleVersion_freewheel] = useState("");
    const [bundleUrl_freewheel, setBundleUrl_freewheel] = useState("");
    const [bundlePolicy_freewheel, setBundlePolicy_freewheel] = useState("SHOW");
    const [bundlePolicyeOptions_freewheel] = useState([{ label: "Show", value: "SHOW" }, { label: "Force", value: "FORCE" }, { label: "Hide", value: "HIDE" }]);


    // -----------------------------------------------------------------------------------------
    const [floorTypePrice_freewheel, setFloorTypePrice_freewheel] = useState("Inherited (Gross)");
    const [floorTypePriceOptions_freewheel] = useState([{ label: "Inherited (Gross)", value: "Inherited (Gross)" }]);

    const [floorPrice_freewheel, setFloorPrice_freewheel] = useState("");
    const [floorPriceIsRequiredError_freewheel, setFloorPriceIsRequiredError_freewheel] = useState(false);
    const [floorPriceValidError_freewheel, setFloorPriceValidError_freewheel] = useState(false);

    // -----------------------------------------------------------------------------------------


    function onChangeName_freewheel(event) {
        setNameIsRequiredError_freewheel(false);
        setName_freewheel(event.target.value);
    }

    function onBlurName_freewheel(event) {
        if (event.target.value.trim().length === 0) {
            setNameIsRequiredError_freewheel(true);
        }
        setName_freewheel(event.target.value.trim());
    }


    function onChangeCategory_freewheel(event) {
        setCategory_freewheel(event);
    }


    function onChangeCheckoxFreewheltv_freewheel(event) {
        setCheckbox_freewheeltv_freewheel(event.target.checked);
    }

    function onChangePassbackUrl_freewheel(event) {
        setPassbackUrl_freewheel(event.target.value);

        setPassbackUrlInvalidUrl_freewheel(false);
        // if (event.target.value.trim().length > 0) {
        //     if (!regexDomain.test(event.target.value.trim())) {
        //         setPassbackUrlInvalidUrl_freewheel(true);
        //     }
        //     else {
        //         setPassbackUrlInvalidUrl_freewheel(false);
        //     }
        // }
        // else {
        //     setPassbackUrlInvalidUrl_freewheel(false);
        // }
    }

    function onBlurPassbackUrl_freewheel(event) {
        setPassbackUrl_freewheel(event.target.value.trim());
        if (event.target.value.trim().length > 0) {
            if (!regexDomain.test(event.target.value.trim())) {
                setPassbackUrlInvalidUrl_freewheel(true);
            }
            else {
                setPassbackUrlInvalidUrl_freewheel(false);
            }
        }

    }

    function onChangeContactName_freewheel(event) {
        setContactNameIsRequiredError_freewheel(false);
        setContactName_freewheel(event.target.value);
    }

    function onBlurContactName_freewheel(event) {
        if (event.target.value.trim().length === 0) {
            setContactNameIsRequiredError_freewheel(true);
        }
        setContactName_freewheel(event.target.value.trim());
    }


    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };


    function onChangeContact_freewheel(event) {
        setContactIsRequiredError_freewheel(false);
        setContact_freewheel(event.target.value);

        if (validateEmail(event.target.value) === null) {
            setContactUrlError_freewheel(true);
        } else {
            setContactUrlError_freewheel(false);
        }
    }

    function onBlurContact_freewheel(event) {
        if (event.target.value.trim().length === 0) {
            setContactUrlError_freewheel(false);
            setContactIsRequiredError_freewheel(true);
        }
        else {
            if (validateEmail(event.target.value.trim()) === null) {
                setContactUrlError_freewheel(true);
            } else {
                setContactUrlError_freewheel(false);
            }
        }
        setContact_freewheel(event.target.value.trim());
    }


    function onChangeAuctionType_freewheel(event) {
        setAuctionType_freewheel(event);
    }

    // -----------------------------------------------------------------------------------------

    function onChangeBundleName_freewheel(event) {
        setBundleName_freewheel(event.target.value);
    }
    function onBlurBundleName_freewheel(event) {
        setBundleName_freewheel(event.target.value.trim());
    }

    function onChangeBundleId_freewheel(event) {
        setBundleId_freewheel(event.target.value);
    }
    function onBlurBundleId_freewheel(event) {
        setBundleId_freewheel(event.target.value.trim());
    }

    function onChangeBundleVersion_freewheel(event) {
        setBundleVersion_freewheel(event.target.value);
    }
    function onBlurBundleVersion_freewheel(event) {
        setBundleVersion_freewheel(event.target.value.trim());
    }

    function onChangeBundleUrl_freewheel(event) {
        setBundleUrl_freewheel(event.target.value);
    }
    function onBlurBundleUrl_freewheel(event) {
        setBundleUrl_freewheel(event.target.value.trim());
    }

    function onChangeBundlePolicy_freewheel(event) {
        setBundlePolicy_freewheel(event);
    }

    // -----------------------------------------------------------------------------------------

    function onChangeFloorPriceType_freewheel(event) {
        setFloorTypePrice_freewheel(event);
    }


    function onChangeFloorPrice_freewheel(event) {

        if (/^\d*\.?\d{0,2}$/.test(event.target.value.trim())) {
            setFloorPrice_freewheel(event.target.value.trim());
            if ((Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 999) || Number(event.target.value.trim()) === 0) {
                setFloorPriceValidError_freewheel(false)
            }
            else {
                setFloorPriceValidError_freewheel(true)
            }

            if (event.target.value.trim().length !== 0) {
                setFloorPriceIsRequiredError_freewheel(false)
            }
        }

        if (event.target.value.trim().length === 0) {
            setFloorPriceValidError_freewheel(false)
            setFloorPriceIsRequiredError_freewheel(true)
        }

    }



    // -----------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------
    const nameRef_site_freewheel = useRef(null)
    const passbackRef_site_freewheel = useRef(null)
    const contactNameRef_site_freewheel = useRef(null)
    const contactRef_site_freewheel = useRef(null)



    const errorDetect = () => {

        if (name_freewheel.trim() === "") {
            scrollToItem(nameRef_site_freewheel);
            return
        }

        if (passbackUrlInvalidUrl_freewheel) {
            scrollToItem(passbackRef_site_freewheel);
            return
        }

        if (contactName_freewheel.trim() === "") {
            scrollToItem(contactNameRef_site_freewheel);
            return
        }

        if (contact_freewheel.trim() === "" || contactUrlError_freewheel) {
            scrollToItem(contactRef_site_freewheel);
            return
        }
    }


    const handleSubmit = async (e) => {
        e.preventDefault();

        errorDetect()

        if (name_freewheel !== "" &&
            contact_freewheel !== "" &&
            contactName_freewheel !== "" &&
            floorPrice_freewheel?.trim() !== ""

        ) {
            if (nameIsRequiredError_freewheel === false &&
                contactNameIsRequiredError_freewheel === false &&
                contactIsRequiredError_freewheel === false &&
                contactUrlError_freewheel === false &&
                passbackUrlInvalidUrl_freewheel === false &&
                floorPriceValidError_freewheel === false &&
                floorPriceIsRequiredError_freewheel === false
            ) {


                let payload = {
                    demand_type: "Freewheel",
                    name: name_freewheel.trim(),
                    site_type: {
                        "label": "Auto Populated (TV: Over-the-top)",
                        "value": "tv-ott"
                    },
                    category: category_freewheel,
                    fw_exc: checkbox_freewheeltv_freewheel,
                    pb_url: passbackUrl_freewheel.trim(),
                    c_name: contactName_freewheel.trim(),
                    c_email: contact_freewheel.trim(),
                    auction_type: auctionType_freewheel,
                    appName: bundleName_freewheel.trim(),
                    appBundle: bundleId_freewheel.trim(),
                    appVersion: bundleVersion_freewheel.trim(),
                    storeUrl: bundleUrl_freewheel.trim(),
                    bundle_policy: bundlePolicy_freewheel,
                    f_amount: floorPrice_freewheel,
                    fp_type: floorTypePrice_freewheel
                }


                setButtonProcessing(true)

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {
                    // setButtonValue(true);
                    let token = Cookies.get("token_xapads_ssp");

                    axios
                        .post(configData.SERVER_URL + `ops/freewheel/createSite`, payload, {
                            headers: {
                                'Content-Type': 'application/json',
                                "x-access-token": token,
                            },
                        })
                        .then((response) => {
                            notifysuccess(response.data.message);
                            setTimeout(() => {
                                // handlePageViewChange("table")
                                handlePageViewChange("table", "yes")
                                // window.location
                            }, 1000)

                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                    setButtonProcessing(false)
                                }
                            } else {
                                notifycatch();
                                setButtonProcessing(false)
                            }

                        });
                }


            }
        } else {
            if (name_freewheel === "") {
                setNameIsRequiredError_freewheel(true);
            }
            if (contactName_freewheel === "") {
                setContactNameIsRequiredError_freewheel(true);
            }

            if (contact_freewheel === "") {
                setContactIsRequiredError_freewheel(true);
            }

            if (floorPrice_freewheel?.trim() === "") {
                setFloorPriceIsRequiredError_freewheel(true);
            }

        }



    }




    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">
                        <li >
                            <Link onClick={() => {
                                handlePageViewChange("table", "no")
                            }}>
                                <img src={demandIcon} alt='USP' />
                                FreeWheel
                            </Link>

                        </li>
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table", "no")
                            }}>

                                Sites
                            </Link>
                        </li>
                        <li className="primary">New Site</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table", "no")

                            }}
                        />
                        <h1 className="heading">
                            Create Site
                        </h1>
                    </div>
                </div>
                <div className="container_box--content pt_20">
                    <div className="container_box--width">
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>General details</label>
                                    <p className="sub_text">Please enter site details</p>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group hide_caret_after_select_value" ref={nameRef_site_freewheel}>
                                                <label className="form_label">Name *</label>
                                                <Input
                                                    className={
                                                        nameIsRequiredError_freewheel
                                                            ? "form_control basic error"
                                                            : "form_control basic"
                                                    }
                                                    value={name_freewheel}
                                                    onBlur={onBlurName_freewheel}
                                                    onChange={onChangeName_freewheel}
                                                    autocomplete="off"
                                                />
                                                <span className="error_content">
                                                    {nameIsRequiredError_freewheel && (
                                                        <> This field is required</>
                                                    )}
                                                </span>

                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Type * </label>
                                                <Input
                                                    className="form_control basic"
                                                    value={type_freewheel}
                                                    autocomplete="off"
                                                    disabled
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Category * </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChangeCategory_freewheel}
                                                    value={category_freewheel}
                                                    options={categoryOptions_freewheel}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group">
                                                <div className="primary_checkbox">
                                                    <Checkbox id="checkbox_freewheeltv_freewheel" name="checkbox_freewheeltv_freewheel"
                                                        checked={checkbox_freewheeltv_freewheel}
                                                        onChange={onChangeCheckoxFreewheltv_freewheel}
                                                    >
                                                        <span className="form_label">
                                                            Exclusive to Freewhel.tv
                                                        </span>
                                                    </Checkbox>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value" ref={passbackRef_site_freewheel}>
                                                <label className="form_label">Passback URL</label>
                                                <TextArea autocomplete="off"
                                                    className={
                                                        passbackUrlInvalidUrl_freewheel
                                                            ? "form_control basic form_control_h --80 textarea_paddingY_d2 error"
                                                            : "form_control basic form_control_h --80 textarea_paddingY_d2"
                                                    }
                                                    value={passbackUrl_freewheel}
                                                    onChange={onChangePassbackUrl_freewheel}
                                                    onBlur={onBlurPassbackUrl_freewheel}
                                                />
                                                <span className="error_content">
                                                    {passbackUrlInvalidUrl_freewheel && (
                                                        <> Invalid Url</>
                                                    )}
                                                </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value" ref={contactNameRef_site_freewheel}>
                                                <label className="form_label">Contact Name *</label>
                                                <Input autocomplete="off"
                                                    className={
                                                        contactNameIsRequiredError_freewheel
                                                            ? "form_control basic error"
                                                            : "form_control basic"
                                                    }
                                                    value={contactName_freewheel}
                                                    onBlur={onBlurContactName_freewheel}
                                                    onChange={onChangeContactName_freewheel}
                                                />
                                                <span className="error_content">
                                                    {contactNameIsRequiredError_freewheel && (
                                                        <> This field is required</>
                                                    )}


                                                </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value" ref={contactRef_site_freewheel}>
                                                <label className="form_label">Contact *</label>
                                                <Input autocomplete="off"
                                                    className={
                                                        contactIsRequiredError_freewheel || contactUrlError_freewheel
                                                            ? "form_control basic error"
                                                            : "form_control basic"
                                                    }
                                                    value={contact_freewheel}
                                                    onBlur={onBlurContact_freewheel}
                                                    onChange={onChangeContact_freewheel}
                                                />
                                                <span className="error_content">
                                                    {contactIsRequiredError_freewheel && (
                                                        <> This field is required</>
                                                    )}
                                                    {contactUrlError_freewheel && (
                                                        <> Invalid Email Address</>
                                                    )}

                                                </span>
                                            </div>
                                            <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                                <label className="form_label">Auction Type * </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    value={auctionType_freewheel}
                                                    onChange={onChangeAuctionType_freewheel}
                                                    options={auctionTypeOptions_freewheel}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>


                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Application</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Name </label>
                                                <Input className='form_control basic ' autocomplete="off"
                                                    value={bundleName_freewheel}
                                                    onChange={onChangeBundleName_freewheel}
                                                    onBlur={onBlurBundleName_freewheel}

                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Bundle ID</label>
                                                <Input className='form_control basic ' autocomplete="off"
                                                    value={bundleId_freewheel}
                                                    onChange={onChangeBundleId_freewheel}
                                                    onBlur={onBlurBundleId_freewheel}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Bundle Policy</label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    value={bundlePolicy_freewheel}
                                                    onChange={onChangeBundlePolicy_freewheel}
                                                    options={bundlePolicyeOptions_freewheel}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Version</label>
                                                <Input className='form_control basic ' autocomplete="off"
                                                    value={bundleVersion_freewheel}
                                                    onChange={onChangeBundleVersion_freewheel}
                                                    onBlur={onBlurBundleVersion_freewheel}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value mb-0">
                                                <label className="form_label">Store URL</label>
                                                <Input className='form_control basic ' autocomplete="off"
                                                    value={bundleUrl_freewheel}
                                                    onChange={onChangeBundleUrl_freewheel}
                                                    onBlur={onBlurBundleUrl_freewheel}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>


                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Floor Prices</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Floor Price Type </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    value={floorTypePrice_freewheel}
                                                    onChange={onChangeFloorPriceType_freewheel}
                                                    options={floorTypePriceOptions_freewheel}
                                                    disabled
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group mb-0 prefixIconCss_d2">
                                                <label className="form_label">Amount *</label>
                                                <Input
                                                    className={
                                                        floorPriceValidError_freewheel || floorPriceIsRequiredError_freewheel
                                                            ? "form_control basic error"
                                                            : "form_control basic"
                                                    }
                                                    autocomplete="off" prefix={'$'}
                                                    value={floorPrice_freewheel}
                                                    onChange={onChangeFloorPrice_freewheel}
                                                />
                                                <span className="error_content">
                                                    {floorPriceIsRequiredError_freewheel && (
                                                        <>This field is required</>
                                                    )}
                                                    {floorPriceValidError_freewheel && (
                                                        <>Value must be less than or equal to 999</>
                                                    )}
                                                </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="hr_custom mb_20"></div>
                    <div className="btn_group justify-content-end gap_8 pb_50">
                        {buttonProcessing ?
                            <>
                                <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                    disabled
                                >
                                    Discard
                                </button>
                                <button
                                    className="w_120_d2 btn btn_primary w_fit_content loader"

                                >
                                    <span>Create Site</span>

                                    <img
                                        src={loaderIcon}
                                        alt="USP"
                                        className="loader_icon"
                                    />
                                </button>
                            </> :
                            <>
                                <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                    onClick={() => {
                                        handlePageViewChange("table", "no")
                                    }}
                                > Discard </button>
                                <button className="w_120_d2 btn btn_primary w_fit_content"
                                    onClick={handleSubmit}
                                >Create Site</button>
                            </>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default SiteCreateFreewheel
